/**
 * @generated SignedSource<<fa5b5bb7e42f6c5f01c2cac7971fc035>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MoqStepType = "CUSTOM" | "FIXED";
export type MoqTargetRuleType = "PRODUCT" | "VARIANT";
export type MoqRuleInput = {
  colors: ReadonlyArray<MoqRuleColorInput>;
  customTiers?: string | null;
  fixedStep?: number | null;
  globalColors: ReadonlyArray<string>;
  id?: string | null;
  minimumQuantity: number;
  name: string;
  printTypes: ReadonlyArray<number>;
  products: ReadonlyArray<number>;
  stepType: MoqStepType;
  targetRuleType: MoqTargetRuleType;
};
export type MoqRuleColorInput = {
  colorID: number;
  productID: number;
};
export type moqRuleEditor_UpdateMoqRuleMutation$variables = {
  input: MoqRuleInput;
};
export type moqRuleEditor_UpdateMoqRuleMutation$data = {
  readonly updateMoqRule: {
    readonly moqRule: {
      readonly customTiers: string;
      readonly fixedStep: number | null;
      readonly id: string;
      readonly minimumQuantity: number;
      readonly name: string;
      readonly stepType: MoqStepType;
      readonly targetRuleType: MoqTargetRuleType;
    } | null;
  };
};
export type moqRuleEditor_UpdateMoqRuleMutation = {
  response: moqRuleEditor_UpdateMoqRuleMutation$data;
  variables: moqRuleEditor_UpdateMoqRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MoqRuleOutput",
    "kind": "LinkedField",
    "name": "updateMoqRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MoqRule",
        "kind": "LinkedField",
        "name": "moqRule",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minimumQuantity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "targetRuleType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stepType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fixedStep",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customTiers",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "moqRuleEditor_UpdateMoqRuleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "moqRuleEditor_UpdateMoqRuleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b2b994e57be2918e4e5071100a13b4b2",
    "id": null,
    "metadata": {},
    "name": "moqRuleEditor_UpdateMoqRuleMutation",
    "operationKind": "mutation",
    "text": "mutation moqRuleEditor_UpdateMoqRuleMutation(\n  $input: MoqRuleInput!\n) {\n  updateMoqRule(input: $input) {\n    moqRule {\n      id\n      name\n      minimumQuantity\n      targetRuleType\n      stepType\n      fixedStep\n      customTiers\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "645e8135a535534bb47c79256cbfdb54";

export default node;
